export default __webpack_public_path__ + "static/media/General_01_01.e026c3d2.png";